"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var AnnotatorFreeform_exports = {};
__export(AnnotatorFreeform_exports, {
  default: () => AnnotatorFreeform_default
});
module.exports = __toCommonJS(AnnotatorFreeform_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.4796 6.94213C6.35255 6.72728 7 5.93925 7 5C7 3.89543 6.10457 3 5 3C3.89543 3 3 3.89543 3 5C3 5.85146 3.53208 6.57865 4.28189 6.86721C4.03946 11.6696 4.67516 15.723 5.68516 18.2136C5.9683 18.9118 6.28897 19.5077 6.64315 19.9677C6.99239 20.4213 7.40925 20.788 7.89763 20.9475C8.41922 21.1177 8.94468 21.0258 9.409 20.7044C9.84848 20.4001 10.2195 19.903 10.5368 19.2684C11.2191 17.9037 11.7496 16.3397 12.3305 14.6274C12.4714 14.212 12.6154 13.7874 12.7651 13.3553C13.5389 11.1218 14.4888 8.60705 16.0268 5.78733C16.3915 5.11871 16.6891 4.71992 16.9154 4.51424C17.0129 4.42557 17.0732 4.39203 17.1042 4.38022C17.1409 4.41048 17.2441 4.51537 17.3736 4.82039C17.5242 5.17526 17.6631 5.68812 17.7848 6.35737C18.2134 8.71515 18.3636 12.6179 18.3939 17.0935C17.5857 17.3502 17 18.1067 17 19C17 20.1046 17.8954 21 19 21C20.1046 21 21 20.1046 21 19C21 18.1023 20.4085 17.3427 19.594 17.0897C19.5639 12.6097 19.4139 8.60968 18.9654 6.14271C18.8371 5.43692 18.6791 4.82475 18.4782 4.35147C18.2906 3.90974 18.0061 3.44367 17.5354 3.25538C16.9884 3.03657 16.4819 3.28659 16.1082 3.62632C15.7328 3.96754 15.3586 4.50629 14.9733 5.21272C13.3896 8.11629 12.4145 10.7016 11.6312 12.9624C11.4737 13.4172 11.3247 13.8562 11.1807 14.2803C10.6025 15.9834 10.1055 17.4477 9.46345 18.7318C9.19145 19.2758 8.93301 19.5744 8.726 19.7177C8.54385 19.8438 8.40581 19.851 8.27004 19.8067C8.10105 19.7515 7.86667 19.5898 7.59398 19.2356C7.32623 18.8879 7.05426 18.3966 6.79721 17.7627C5.87162 15.4802 5.24522 11.6163 5.4796 6.94213ZM17.13 4.37508C17.1302 4.37413 17.1256 4.37363 17.1155 4.37643C17.1247 4.37743 17.1297 4.37603 17.13 4.37508Z",
      fill: "currentColor"
    }
  )
);
const SvgAnnotatorFreeform = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var AnnotatorFreeform_default = SvgAnnotatorFreeform;
